<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
              <message :messages="messages"></message>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Selection Criteria
              </div>
            </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-select
                    v-model="form.acctPeriod"
                    :items="acctPeriodList"
                    :label="labels.acctPeriod"
                    data-vv-name="acctPeriod"
                    :data-vv-as="labels.acctPeriod"
                    :error-messages="errors.collect('acctPeriod')"
                    v-validate="'required'"
                    item-text="monthYearText"
                    item-value="acctPerEndDate"
                  />
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    v-model="form.curr"
                    :items="currItems"
                    :label="labels.curr"
                    data-vv-name="curr"
                    :data-vv-as="labels.curr"
                    :error-messages="errors.collect('curr')"
                    v-validate="'required'"
                    item-text="currDesc"
                    item-value="curr"
                  />
                </v-flex>
              </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-spacer class="mt-2"></v-spacer>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-expansion-panels v-model="panel" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <div><v-icon>mdi-filter-variant</v-icon> Filter</div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12 sm6>
                                <v-text-field
                                  v-model="form.acctNoFrom"
                                  :label="labels.acctNoFrom"
                                  :error-messages="errors.collect('acctNoFrom')"
                                  data-vv-name="acctNoFrom"
                                  :data-vv-as="labels.acctNoFrom"
                                  append-icon="mdi-magnify"
                                  readonly
                                  @click:append="
                                    showIntermediaryHelpList = true
                                    selectedInterField = 'acctNoFrom'
                                  "
                                  clearable
                                  v-validate="acctNoValidate('acctNoFrom')"
                                />
                              </v-flex>
                              <v-flex xs12 sm6>
                                <v-text-field
                                  v-model="form.acctNoTo"
                                  :label="labels.acctNoTo"
                                  :error-messages="errors.collect('acctNoTo')"
                                  data-vv-name="acctNoTo"
                                  :data-vv-as="labels.acctNoTo"
                                  append-icon="mdi-magnify"
                                  readonly
                                  @click:append="
                                    showIntermediaryHelpList = true
                                    selectedInterField = 'acctNoTo'
                                  "
                                  clearable
                                  v-validate="acctNoValidate('acctNoTo')"
                                />
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs12 sm6>
                                <v-text-field
                                  v-model="form.branch"
                                  :label="labels.branch"
                                  :error-messages="errors.collect('branch')"
                                  data-vv-name="branch"
                                  :data-vv-as="labels.branch"
                                  append-icon="mdi-magnify"
                                  readonly
                                  @click:append="showBranchHelpList = true"
                                  v-validate="'required'"
                                />
                              </v-flex>
                              <v-flex xs6 sm3 class="d-flex justify-center">
                                <v-checkbox
                                  v-model="form.combineBranch"
                                  :label="labels.combineBranch"
                                  data-vv-name="combineBranch"
                                  :data-vv-as="labels.combineBranch"
                                ></v-checkbox>
                              </v-flex>
                              <v-flex xs6 sm3>
                                <v-autocomplete
                                  :items="branches"
                                  :label="labels.thisBranch"
                                  v-model="form.thisBranch"
                                  item-text="label"
                                  item-value="value"
                                  :error-messages="errors.collect('form.thisBranch')"
                                  data-vv-name="form.thisBranch"
                                  :data-vv-as="labels.thisBranch"
                                  v-validate="combineBranchValidate"
                                  :disabled="this.form.combineBranch === false"
                                >
                                </v-autocomplete>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs12 sm6>
                                <v-text-field
                                  v-model="form.fund"
                                  :label="labels.fund"
                                  :error-messages="errors.collect('fund')"
                                  data-vv-name="fund"
                                  :data-vv-as="labels.fund"
                                  append-icon="mdi-magnify"
                                  readonly
                                  @click:append="showFundHelpList = true"
                                  v-validate="'required'"
                                />
                              </v-flex>
                              <v-flex xs12 sm6>
                                <v-text-field
                                  v-model="form.acctNoSfx"
                                  :label="labels.acctNoSfx"
                                  :error-messages="errors.collect('acctNoSfx')"
                                  data-vv-name="acctNoSfx"
                                  :data-vv-as="labels.acctNoSfx"
                                  append-icon="mdi-magnify"
                                  readonly
                                  @click:append="showAcctNoSfxHelpList = true"
                                  v-validate="'required'"
                                />
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-flex>
              </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-flex xs12>
      <v-checkbox v-model="form.prtRptRunTime" :label="labels.prtRptRunTime" data-vv-name="prtRptRunTime"
        :data-vv-as="labels.prtRptRunTime" />
    </v-flex>
    <v-flex xs12>
      <!-- <v-btn class="mr-2" color="info" :loading="submitting" @click.prevent="doSchedule">
        <v-icon left dark>mdi-clock</v-icon>
        Schedule
      </v-btn> -->
      <v-btn class="mr-2" color="accent" dark :loading="submitting" @click.prevent="doReset">
        {{ labels.reset }}
        <v-icon dark right>mdi-refresh</v-icon>
      </v-btn>
      <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
        <v-icon left dark>mdi-file-export</v-icon>
        {{ labels.export }}
      </v-btn>
      <v-btn-toggle dense mandatory v-model="form.format">
        <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
          <span>{{ format.label }}</span>
          <v-icon :color="format.color">{{ format.icon }}</v-icon>
        </v-btn>
      </v-btn-toggle>
    </v-flex>
    <v-dialog v-model="showIntermediaryHelpList" width="900px" persistent>
      <intermediary-help-list :interGrps="'10,11,13,20,25'" @close="showIntermediaryHelpList = false" headerInfo="default" @assign-intermediary-data="assignInterInfo"></intermediary-help-list>
    </v-dialog>
    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <multi-branch-help-list :brn="form.branch" @close="showBranchHelpList = false" @doAssign="doAssignBranch($event)"></multi-branch-help-list>
    </v-dialog>
    <v-dialog v-model="showFundHelpList" width="900px" persistent>
      <multi-fund-help-list :fnd="form.fund" @close="showFundHelpList = false" @doAssign="doAssignFund($event)"></multi-fund-help-list>
    </v-dialog>
    <v-dialog v-model="showAcctNoSfxHelpList" width="900px" persistent>
      <multi-acct-no-sfx-help-list :acctNoSfx="form.acctNoSfx" @close="showAcctNoSfxHelpList = false" @doAssign="doAssignAcctNoSfx($event)"></multi-acct-no-sfx-help-list>
    </v-dialog>
    <v-dialog v-model="scheduleJobModal" width="1000px" persistent>
      <ScheduleJob @close="scheduleJobModal = false" :jobName="jobName" :jobDesc="jobDesc"></ScheduleJob>
    </v-dialog>
  </page>
</template>

<script>
import { reportFormat } from '@/const/report'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import IntermediaryHelpList from '@/components/core/common/dialog/IntermediaryHelpList'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList.vue'
import MultiFundHelpList from '@/components/core/common/dialog/MultiFundHelpList.vue'
import MultiAcctNoSfxHelpList from '@/components/core/common/dialog/MultiAcctNoSfxHelpList.vue'
import { acctNoRangeFrom, acctNoRangeTo } from './index'
import ScheduleJob from '@/components/core/common/dialog/ScheduleJob'

export default {
  data() {
    return {
      labels: {
        acctPeriod: 'Accounting Period',
        curr: 'Base Currency',
        branch: 'Branch',
        fund: 'Fund',
        acctNoFrom: 'Account No. From',
        acctNoTo: 'Account No. To',
        acctNoSfx: 'Account No. Suffix',
        combineBranch: 'Combine Branch to',
        thisBranch: 'This Branch',
        export: 'Export to',
        prtRptRunTime: 'Print Runtime Parameters',
        cancel: 'Cancel',
        reset: 'Reset'
      },
      form: {
        acctPeriod: undefined,
        curr: undefined,
        branch: 'All',
        fund: 'All',
        acctNoSfx: 'All',
        acctNoFrom: undefined,
        acctNoTo: undefined,
        combineBranch: false,
        thisBranch: undefined,
        format: 'PDF',
        prtRptRunTime: true
      },
      acctPeriodList: [],
      currItems: [],
      branchList: [],
      branches: [],
      menu: {},
      supportedFormat: [],
      showBranchHelpList: false,
      showFundHelpList: false,
      showAcctNoSfxHelpList: false,
      showIntermediaryHelpList: false,
      selectedInterField: undefined,
      submitting: false,
      paginationCurr: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 500 // get all, probably
      },
      panel: [0],
      scheduleJobModal: false,
      jobName: 'clmIOTaxReport',
      jobDesc: 'Claims Input and Output Tax'
    }
  },
  computed: {
    combineBranchValidate() {
      if (this.form.combineBranch === true) {
        return 'required'
      }
      return ''
    },
    rptMenu() {
      return this.$store.state.reports.acctReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    'form.combineBranch': function(val) {
      if (val === false) {
        this.form.thisBranch = ''
      }
    }
  },
  methods: {
    async doInit() {
      this.resetMessages()
      this.getBranchList()
      this.getAcctPeriods('3').then(result => {
        const today = new Date()
        const year = today.getFullYear()
        const month = today.getMonth() + 1
        for (let acctPeriod of this.acctPeriodList) {
          if (acctPeriod.acctPerMth === month && acctPeriod.acctPerYr === year) {
            this.form.acctPeriod = acctPeriod.acctPerEndDate
          }
        }
      })
      this.fetchCurrData().then(res => {
        if (this.currItems) {
          for (let currItem of this.currItems) {
            currItem.currDesc = currItem.curr + ' - ' + currItem.currDesc
          }
        }
      })
      await this.$store.dispatch('acctReportsInit')
      const apiURI = this.rptMenu.clmIOTaxReport
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.form.curr = data.companyCurr
            this.menu = extractMenu(result.data._links)
          }
        }
      } else {
        this.$toast.error('Missing API URI (ClmIOTax Report)')
      }
    },
    async assignInterInfo(data) {
      switch (this.selectedInterField) {
        case 'acctNoFrom':
          this.form.acctNoFrom = data.inter
          this.$validator.validate('acctNoFrom')
          break
        case 'acctNoTo':
          this.form.acctNoTo = data.inter
          this.$validator.validate('acctNoTo')
          break
        default:
      }
    },
    acctNoValidate(field) {
      if (field === 'acctNoFrom') {
        if (this.form.acctNoTo === '') {
          return 'required'
        } else {
          if (this.form.acctNoTo) {
            return 'required|acctNoRangeFrom:' + this.form.acctNoTo
          } else {
            return ''
          }
        }
      } else {
        if (this.form.acctNoFrom) {
          return 'required|acctNoRangeTo:' + this.form.acctNoFrom
        } else {
          return ''
        }
        // }
      }
    },
    async doAssignBranch(Obj) {
      this.form.branch = Obj.finalSelectedItems.toString()
      this.$validator.validate('branch')
    },
    async doAssignFund(Obj) {
      this.form.fund = Obj.finalSelectedItems.toString()
      this.$validator.validate('fund')
    },
    async doAssignAcctNoSfx(Obj) {
      this.form.acctNoSfx = Obj.finalSelectedItems.toString()
      this.$validator.validate('acctNoSfx')
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.exportClmIOTaxReport
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doSchedule() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.scheduleJob()
        }
      })
    },
    scheduleJob() {
      this.scheduleJobModal = true
    },
    async doCancel() {
      this.$router.push({ name: 'reportAcct' }).catch(() => {})
    },
    async doReset() {
      this.doInit()
      this.form.branch = 'All'
      this.form.fund = 'All'
      this.form.acctNoSfx = 'All'
      this.form.acctNoFrom = undefined
      this.form.acctNoTo = undefined
      this.form.combineBranch = false
      this.form.thisBranch = undefined
      this.form.format = 'PDF'
      this.form.prtRptRunTime = false
    }
  },
  created() {
    this.doInit()
    // custom validation
    this.$validator.extend('acctNoRangeFrom', acctNoRangeFrom)
    this.$validator.extend('acctNoRangeTo', acctNoRangeTo)
  },
  mixins: [MessageMixin, commonAjaxMixin],
  components: {
    MultiBranchHelpList,
    MultiFundHelpList,
    MultiAcctNoSfxHelpList,
    IntermediaryHelpList,
    ScheduleJob
  }
}
</script>
